import React, { useState } from "react";
import "../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../src/style/buttons.scss";
import { MdOutlineClear, MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { AiOutlineCalendar } from "react-icons/ai";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import EAIconButton from "../../shared/Buttons/EAIconButton";
import ExerciseFltersModal from "./ExerciseFilters/ExerciseFltersModal";
import useAdditionalHooks, { ExerciseFiltersObject } from "../hooks/useAdditionalHooks";
import useMediaQuery from "@mui/material/useMediaQuery";
import EACalendarModal from "../../shared/CalendarModal/EACalendarModal";

interface IProps {
  nextWeek: () => void;
  previousWeek: () => void;
  nextDay: () => void;
  previousDay: () => void;
  dateFromState: Date;
  dateToState: Date;
  dateFromStateMobile: Date;
  dateToStateMobile: Date;
  filters: ExerciseFiltersObject;
  setFilters: (filters: ExerciseFiltersObject) => void;
  onMobileDateChange: (date: Date) => void;
  onDesktopDateChange: (date: Date) => void;
}

const ExerciseBar: React.FC<IProps> = ({
  nextWeek,
  previousWeek,
  nextDay,
  previousDay,
  dateFromState,
  dateToState,
  dateFromStateMobile,
  dateToStateMobile,
  filters,
  setFilters,
  onMobileDateChange,
  onDesktopDateChange,
}) => {
  const [open, setOpen] = useState(false);
  const [openCalendar, setOpenCalendar] = useState(false);
  const { t } = useTranslation();
  const { isSomeFiltersSelected, handleResetFilters } = useAdditionalHooks(filters, setFilters);
  const isDesktop = useMediaQuery("(min-width: 1100px)");

  const handleOpenCalendar = () => {
    setOpenCalendar(true);
  };

  const handleCloseCalendar = () => {
    setOpenCalendar(false);
  };

  const handleDateChange = (date: Date) => {
    if (isDesktop) {
      onDesktopDateChange(date);
    } else {
      onMobileDateChange(date);
    }
    setOpenCalendar(false);
  };

  return (
    <>
      <div className={`schedule-bar ${isDesktop ? "desktop" : "mobile"}`}>
        {isDesktop ? (
          <>
            <div className="flex-start-center">
              <EAButton
                title={isSomeFiltersSelected() ? t("wybrano_filtry") : t("filtry")}
                onClick={() => setOpen(true)}
                variant="outlined"
              />
              {isSomeFiltersSelected() && (
                <EAButton
                  title={t("wyczysc_filtry")}
                  onClick={handleResetFilters}
                  startIcon={<MdOutlineClear />}
                  variant="text"
                />
              )}
            </div>
            <div className="schedule-bar__buttons">
              <EAIconButton
                title="Poprzedni tydzień"
                icon={<MdOutlineKeyboardArrowLeft />}
                variant="outlined"
                onClick={previousWeek}
              />
              <EAButton
                title={`${format(dateFromState, "dd.MM")} - ${format(dateToState, "dd.MM.yyyy")}`}
                endIcon={<AiOutlineCalendar />}
                onClick={handleOpenCalendar}
                variant="outlined"
              />
              <EAIconButton title="Następny tydzień" icon={<MdOutlineKeyboardArrowRight />} onClick={nextWeek} />
            </div>
          </>
        ) : (
          <>
          {/* <div className="schedule-bar-wrapper">
            <div className="schedule-bar__navigation">
              <EAIconButton title="Poprzedni dzień" icon={<MdOutlineKeyboardArrowLeft />} onClick={previousDay} />
              <EAIconButton title="Następny dzień" icon={<MdOutlineKeyboardArrowRight />} onClick={nextDay} />
              <EAIconButton
                title="Wybór dnia"
                icon={<AiOutlineCalendar />}
                variant="filled"
                onClick={handleOpenCalendar}
              />
            </div>
            <div className="schedule-bar__filters">
              <EAIconButton
                title={isSomeFiltersSelected() ? t("wybrano_filtry") : t("filtry")}
                onClick={() => setOpen(true)}
                variant="outlined"
                icon={<MdFilterList />}
              />
              {isSomeFiltersSelected() && (
                <EAIconButton
                  title={t("wyczysc_filtry")}
                  onClick={handleResetFilters}
                  icon={<MdOutlineClear />}
                  variant="icon"
                />
              )}
            </div>
          </div> */}
          </>
        )}
      </div>

      {open && (
        <ExerciseFltersModal
          open={open}
          setOpen={setOpen}
          dateFromState={isDesktop ? dateFromState : dateFromStateMobile}
          dateToState={isDesktop ? dateToState : dateToStateMobile}
          filters={filters}
          setFilters={setFilters}
        />
      )}

      {openCalendar && <EACalendarModal onClose={handleCloseCalendar} onDatePick={handleDateChange} />}
    </>
  );
};

export default ExerciseBar;
